import React, { Table } from 'tea-component';
import SvgIcon from '@gp/components/Iconfont';
import GeneralImageNew from '@gp/components/GeneralImageNew';
// @ts-ignore
import style from '../../index.module.scss';
import DEFAULT_COUNTRY_ICON from '@gp/assets/svg/flag-default.svg';
const { selectable, scrollable } = Table.addons;

interface Props {
  dataSource: any;
  targetKeys: any;
  onChange: (key: any) => void;
}

export default function SourceTable(props: Props) {
  const { dataSource, targetKeys, onChange, allCountryFlag } = props;

  const LEFT_COLUMNS = [
    {
      key: 'game',
      render: (cvm) => {
        return (
          <div className="dbg-similar-modal-table">
            <GeneralImageNew
              className="dbg-similar-modal-table-img"
              domain="game"
              width={36}
              height={36}
              src={cvm?.cover}
            />
            <div className="dbg-similar-modal-table-context">
              <div className="dbg-similar-modal-table-name">{cvm.entity_name}</div>
              <div className="dbg-similar-modal-table-massage">
                <span className="dbg-similar-modal-table-icon">
                  <SvgIcon type={cvm.entity_type} />
                </span>
                {/* <SvgIcon type={cvm.entity_type} className='dbg-similar-modal-table-icon' /> */}
                <img
                  className="dbg-similar-modal-table-countryicon"
                  src={allCountryFlag[cvm?.country_en_name_abbr] || DEFAULT_COUNTRY_ICON}
                  onError={(e) => {
                    e.target.src = DEFAULT_COUNTRY_ICON;
                  }}
                />
                <span className="dbg-similar-modal-table-text">{cvm.publisher}</span>
              </div>
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <Table
      records={dataSource}
      recordKey="game_id"
      rowClassName={(record) => record.status}
      columns={LEFT_COLUMNS}
      hideHeader
      addons={[
        scrollable({
          virtualizedOptions: {
            height: 345,
            itemHeight: 64,
            onScrollBottom: () => {},
          },
        }),
        selectable({
          value: targetKeys,
          onChange,
          rowSelect: true,
        }),
      ]}
    />
  );
}
